import styled from 'styled-components';

export const Favicon = styled.img.withConfig({ displayName: 'FavIcon' })`
  width: 20px;
  margin-right: 20px;
`;
